import { Component, OnInit } from '@angular/core';
import { HomeComponent } from '../../home/home.component';
import { UserService } from '../../services/user/user.service';
import { User } from '../../model/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtService } from '../../auth/jwt.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isLoginError: boolean = false;
  isLoading: boolean = false;
  errorString : string;

  constructor(private homeComponent: HomeComponent,
    private userService: UserService, private router: Router,
    private jwtServices: JwtService) { }

  ngOnInit() {
  }


  ShowRegister() {
    this.homeComponent.showregisterscreen = true;
    this.homeComponent.showloginscreen = false;
    this.homeComponent.showforgotscreen = false;
  }

  OnSubmit(Email, password) {
    this.isLoading = true;
    this.errorString = "";
    this.userService.userAuthentication(Email, password).subscribe((data: any) => {
      if (data.succeeded.accessToken != null && data.succeeded != "false") {
        //localStorage.setItem('userToken', data.accessToken);
        this.jwtServices.saveToken(data.succeeded.accessToken);
        this.userService.setAuth(data.succeeded);
        this.router.navigate(['/dashboard']);
        this.isLoading = false;
      }
      else if(data.succeeded == false) {
        this.isLoginError = true;
        this.isLoading = false;
        this.errorString = data.error;
      }

    },
      (err: HttpErrorResponse) => {
        this.isLoginError = true;
        this.isLoading = false;
      });
  }

  login() {
    this.userService.login();
  }

  ShowForgot()
  {
    this.homeComponent.showregisterscreen=false;
    this.homeComponent.showloginscreen=false;
    this.homeComponent.showforgotscreen = true;
  }

}
